import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

// A gentle upgrade wall shown when a free user reaches a premium feature.
export default function Paywall({ title, message, tier = "Seeker", testId = "paywall" }) {
  return (
    <div data-testid={testId} className="glass rounded-3xl p-10 sm:p-16 text-center max-w-2xl mx-auto gold-glow">
      <div className="mx-auto h-16 w-16 rounded-full bg-[#D4AF37]/10 grid place-items-center text-[#D4AF37]">
        <Lock size={28} />
      </div>
      <h2 className="mt-6 serif text-3xl text-[#F7F1E6]">{title}</h2>
      <p className="mt-4 text-[#B4A897] leading-relaxed text-lg">{message}</p>
      <Link
        to="/pricing"
        data-testid={`${testId}-cta`}
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#D4AF37] text-[#17100C] px-8 py-3.5 font-medium hover:bg-[#e6c860] transition-colors duration-300"
      >
        Become a {tier} <ArrowRight size={18} />
      </Link>
    </div>
  );
}
